class LambdaCountdownEvent
{
    static initEventCountdowns()
    {
        var elems = document.querySelectorAll('[data-event-countdown="1"]').forEach(el => this.setupElements(el));
    }

    static setupElements(el)
    {
        let countdown = LambdaCountdown.fromElement(el);
        countdown.setTickCallback(data => this.countdownUpdate(el, data));

        this.setupMarkup(el, countdown);

    }

    static setupMarkup(el, countdown)
    {
        var html = ``;

        if(countdown.hasYears()) {
            html += this.newCountdownDom('years', 'Years');
        }

        if(countdown.hasMonths()) {
            html += this.newCountdownDom('months', 'Months');
        }

        if(countdown.hasWeeks()) {
            html += this.newCountdownDom('weeks', 'Weeks');
        }

        html += this.newCountdownDom('days', 'Days');
        html += this.newCountdownDom('hours', 'Hours');
        html += this.newCountdownDom('minutes', 'Minutes');
        html += this.newCountdownDom('seconds', 'Seconds');

        el.innerHTML = html;

    }

    static newCountdownDom(type, name)
    {
        return `
            <div class="flex flex-col gap-2 items-center justify-center">
                <div class="text-xl lg:text-4xl font-bold uppercase text-white" data-countdown-domtype="${type}">0</div>
                <div class="text-sm uppercase text-gray-400">${name}</div>
            </div>`
    }

    static countdownUpdate(el, data)
    {
        //console.log('Countdown update for ', el, ' with data: ', data);

        var yearDom = el.querySelector('[data-countdown-domtype="years"]');
        var monthDom = el.querySelector('[data-countdown-domtype="months"]');
        var weekDom = el.querySelector('[data-countdown-domtype="weeks"]');
        var dayDom = el.querySelector('[data-countdown-domtype="days"]');
        var hourDom = el.querySelector('[data-countdown-domtype="hours"]');
        var minuteDom = el.querySelector('[data-countdown-domtype="minutes"]');
        var secondDom = el.querySelector('[data-countdown-domtype="seconds"]');

        if(yearDom) {
            yearDom.innerText = String(data.Years).padStart(2, '0');
        }

        if(monthDom) {
            monthDom.innerText = String(data.Months).padStart(2, '0');
        }

        if(weekDom) {
            weekDom.innerText = String(data.Weeks).padStart(2, '0');
        }

        if(dayDom) {
            dayDom.innerText = String(data.Days).padStart(2, '0');
        }

        if(hourDom) {
            hourDom.innerText = String(data.Hours).padStart(2, '0');
        }

        if(minuteDom) {
            minuteDom.innerText = String(data.Minutes).padStart(2, '0');
        }

        if(secondDom) {
            secondDom.innerText = String(data.Seconds).padStart(2, '0');
        }

    }

}

export default LambdaCountdownEvent;
